var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6571 3.64509C26.5336 0.398901 21.4596 0.398901 18.3228 3.64509L16.9998 5.02268L15.6768 3.64509C12.5534 0.398901 7.47929 0.398901 4.34258 3.64509C1.21914 6.89129 1.21914 12.1423 4.34258 15.3889L16.9727 28.4966L17 28.4693L17.0273 28.4966L29.6574 15.3889C32.7809 12.1427 32.7809 6.89165 29.6574 3.64509H29.6571Z",
    fill: "#9B7BD0",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5476 5.73932C24.9447 3.03416 20.7163 3.03416 18.1024 5.73932L16.9998 6.88731L15.8973 5.73932C13.2945 3.03416 9.06608 3.03416 6.45215 5.73932C3.84928 8.44448 3.84928 12.8203 6.45215 15.5258L16.9773 26.4489L17 26.4261L17.0227 26.4489L27.5479 15.5258C30.1507 12.8206 30.1507 8.44478 27.5479 5.73932H27.5476Z",
    fill: "#5A8C8D",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.438 7.83355C23.3557 5.66942 19.973 5.66942 17.8819 7.83355L16.9999 8.75194L16.1179 7.83355C14.0356 5.66942 10.6529 5.66942 8.56172 7.83355C6.47943 9.99767 6.47943 13.4983 8.56172 15.6627L16.9818 24.4012L17 24.383L17.0182 24.4012L25.4383 15.6627C27.5206 13.4986 27.5206 9.99792 25.4383 7.83355H25.438Z",
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3285 9.92777C21.7668 8.30468 19.2298 8.30468 17.6614 9.92777L16.9999 10.6166L16.3384 9.92777C14.7767 8.30468 12.2396 8.30468 10.6713 9.92777C9.10957 11.5509 9.10957 14.1764 10.6713 15.7997L16.9864 22.3535L17 22.3399L17.0136 22.3535L23.3287 15.7997C24.8904 14.1766 24.8902 11.551 23.3285 9.92777Z",
    fill: "#9B7BD0",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4179 11.6975C20.3119 10.5481 18.5153 10.5481 17.4046 11.6975L16.9362 12.1853L16.4677 11.6975C15.3618 10.5481 13.5651 10.5481 12.4545 11.6975C11.3485 12.8469 11.3485 14.7062 12.4545 15.8558L16.9266 20.497L16.9363 20.4873L16.9459 20.497L21.418 15.8558C22.524 14.7064 22.5239 12.8471 21.4179 11.6975Z",
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9393 13.1635C19.1977 12.3928 17.9931 12.3928 17.2484 13.1635L16.9343 13.4905L16.6201 13.1635C15.8786 12.3928 14.6739 12.3928 13.9292 13.1635C13.1877 13.9342 13.1877 15.1809 13.9292 15.9516L16.9278 19.0636L16.9343 19.0572L16.9408 19.0636L19.9394 15.9516C20.6809 15.1809 20.6808 13.9343 19.9393 13.1635Z",
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4646 14.6294C18.0874 14.2375 17.4747 14.2375 17.096 14.6294L16.9362 14.7958L16.7765 14.6294C16.3993 14.2375 15.7866 14.2375 15.4079 14.6294C15.0307 15.0214 15.0307 15.6555 15.4079 16.0475L16.933 17.6302L16.9362 17.627L16.9395 17.6302L18.4646 16.0475C18.8418 15.6555 18.8417 15.0215 18.4646 14.6294Z",
    fill: "#9B7BD0",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart2);
export default __webpack_public_path__ + "static/media/Heart-2.d1a2473cc74e59a94ab07edf51ebe6ce.svg";
export { ForwardRef as ReactComponent };